import api from './api';

const adminService = {
  // Dashboard admin
  getDashboard: () => api.get('/admin/dashboard'),

  // Configuración
  getSettings: (category) => api.get('/admin/settings', { params: { category } }),
  updateSetting: (key, value) => api.put(`/admin/settings/${key}`, { value }),
  updateSettingsBulk: (settings) => api.put('/admin/settings', { settings }),

  // NCF
  getNcfSequences: () => api.get('/admin/ncf-sequences'),
  updateNcfSequence: (id, data) => api.put(`/admin/ncf-sequences/${id}`, data),

  // Auditoría
  getAuditLogs: (params) => api.get('/admin/audit-log', { params }),

  // Usuarios extendidos
  updateUser: (id, data) => api.put(`/admin/users/${id}`, data),
  resetPassword: (id, new_password) => api.put(`/admin/users/${id}/password`, { new_password }),
  toggleUser: (id) => api.patch(`/admin/users/${id}/toggle`),

  // Exportación
  exportData: (entity) => api.get(`/admin/export/${entity}`),
};

export default adminService;
